<mibi-single-center-card-layout
    *ngIf="adminTokenValid; else invalidToken"
    cardTitle="Konto aktiviert"
>
    <p mibi-card-content class="mibi-last">
        Sie haben das {{ appName }} Konto für {{ name }} als Admin aktiviert.
    </p>
</mibi-single-center-card-layout>

<ng-template #invalidToken>
    <mibi-single-center-card-layout cardTitle="Fehler">
        <p mibi-card-content class="mibi-last">Ihre Admin Kontoaktivierung ist fehlgeschlagen.</p>
    </mibi-single-center-card-layout>
</ng-template>
